import { ThirdPartyAndComprehensiveSection } from "./view";
export default ThirdPartyAndComprehensiveSection;
